import React, { useState, useEffect } from 'react';
import './DateWidget.css';

export default function DateWidget() {
  const [showCalendar, setShowCalendar] = useState(false);
  const [calendarData, setCalendarData] = useState(null);
  
  const now = new Date();
  const day = now.getDate();
  const monthNames = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
  const dayNames = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];
  
  const month = monthNames[now.getMonth()];
  const dayName = dayNames[now.getDay()];
  const isWeekend = now.getDay() === 0 || now.getDay() === 6;
  
  // Загружаем календарь из онлайн источника для проверки
  useEffect(() => {
    loadCalendar();
  }, []);
  
  const loadCalendar = async () => {
    try {
      // Получаем актуальную дату из онлайн источника для проверки
      const timeResponse = await fetch('https://worldtimeapi.org/api/timezone/Europe/Moscow', {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
        },
      });
      
      let actualDate = now;
      if (timeResponse.ok) {
        const timeData = await timeResponse.json();
        actualDate = new Date(timeData.datetime);
      }
      
      const currentYear = actualDate.getFullYear();
      const currentMonth = actualDate.getMonth();
      
      // getDay() возвращает: 0=воскресенье, 1=понедельник, ..., 6=суббота
      // Но календарь начинается с понедельника, поэтому нужно преобразовать
      const firstDayOfMonth = new Date(currentYear, currentMonth, 1);
      // Преобразуем: воскресенье (0) -> 6, понедельник (1) -> 0, ..., суббота (6) -> 5
      const firstDay = firstDayOfMonth.getDay() === 0 ? 6 : firstDayOfMonth.getDay() - 1;
      const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
      
      const days = [];
      // Пустые ячейки для дней до начала месяца (неделя начинается с понедельника)
      for (let i = 0; i < firstDay; i++) {
        days.push(null);
      }
      // Дни месяца
      for (let i = 1; i <= daysInMonth; i++) {
        days.push(i);
      }
      
      setCalendarData({
        days,
        firstDay,
        daysInMonth,
        currentYear,
        currentMonth,
      });
    } catch (err) {
      console.error('Error loading calendar from API, using local time:', err);
      // Fallback на локальные вычисления
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth();
      const firstDayOfMonth = new Date(currentYear, currentMonth, 1);
      const firstDay = firstDayOfMonth.getDay() === 0 ? 6 : firstDayOfMonth.getDay() - 1;
      const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
      
      const days = [];
      for (let i = 0; i < firstDay; i++) {
        days.push(null);
      }
      for (let i = 1; i <= daysInMonth; i++) {
        days.push(i);
      }
      
      setCalendarData({
        days,
        firstDay,
        daysInMonth,
        currentYear,
        currentMonth,
      });
    }
  };
  
  // Используем загруженные данные или вычисляем локально
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth();
  const firstDayOfMonth = new Date(currentYear, currentMonth, 1);
  // Преобразуем воскресенье (0) в 6, остальные дни уменьшаем на 1
  const firstDay = firstDayOfMonth.getDay() === 0 ? 6 : firstDayOfMonth.getDay() - 1;
  const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
  
  const calendarDays = calendarData?.days || (() => {
    const days = [];
    for (let i = 0; i < firstDay; i++) {
      days.push(null);
    }
    for (let i = 1; i <= daysInMonth; i++) {
      days.push(i);
    }
    return days;
  })();
  
  return (
    <div 
      className="date-widget"
      onMouseEnter={() => setShowCalendar(true)}
      onMouseLeave={() => setShowCalendar(false)}
    >
      <div className="date-display">
        <span className="date-day">{day}</span>
        <span className="date-month">{month}</span>
        <span className={`date-weekday ${isWeekend ? 'weekend' : 'weekday'}`}>
          {dayName}
        </span>
      </div>
      
      {showCalendar && (
        <div className="calendar-popup">
          <div className="calendar-header">
            <span className="calendar-month-year">
              {monthNames[currentMonth].charAt(0).toUpperCase() + monthNames[currentMonth].slice(1)} {currentYear}
            </span>
          </div>
          <div className="calendar-weekdays">
            {['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'].map((day, idx) => (
              <div key={idx} className="calendar-weekday">{day}</div>
            ))}
          </div>
          <div className="calendar-days">
            {calendarDays.map((day, idx) => {
              if (day === null) {
                return (
                  <div key={idx} className="calendar-day empty"></div>
                );
              }
              
              const isToday = day === now.getDate();
              // Вычисляем реальный день недели для этого числа
              const dateForDay = new Date(currentYear, currentMonth, day);
              const actualDayOfWeek = dateForDay.getDay(); // 0=воскресенье, 6=суббота
              const isActuallyWeekend = actualDayOfWeek === 0 || actualDayOfWeek === 6;
              
              return (
                <div
                  key={idx}
                  className={`calendar-day ${isToday ? 'today' : ''} ${isActuallyWeekend ? 'weekend' : ''}`}
                >
                  {day}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
